import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import EventCard from "./EventCard.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class Events extends Component {
    render() {
        const events = this.props.events.map((event, i) => {
            return <EventCard event={event} key={`event${i + 1}`} />;
        });

        const pastEvents = this.props.pastEvents.map((event, i) => {
            return <EventCard event={event} key={`event${i + 1}`} />;
        });

        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background events">
                    <Banner heading="Events" />
                    <BackButton href={hyperlinks["home"]} text="❮ Home" />
                    <div className="events-content">
                        <Row>
                            <Col md={8} mdOffset={2}>
                                <p>
                                    The Leading Utilities of the World (LUOW) initiative was launched during the Global Water Summit 2017 in Madrid. This was the inaugural meeting of the Advisory Board and the first group of new members of the network.
                                </p>

                                <p>
                                    Face-to-face meetings are a vital part of the LUOW initiative’s operations. These will be held at a variety of different international water conferences across Europe, Asia and North America.
                                </p>

                                <p>
                                    LUOW events include presentations from prospective new members, reviews from the Advisory Board, and presentation of trophies and certificates to successful new members.
                                </p>

                                <p>
                                    There are also regular online networking events, where members continue to meet.
                                </p>

                                <p>
                                    Confirmed face-to-face meetings are listed below.
                                </p>

                                <p>
                                    If you would like to hold a LUOW meeting at your event, please send an expression of interest to <a href="mailto:contact@leadingutilities.org">contact@leadingutilities.org</a>.
                                </p>
                            </Col>
                        </Row>

                        {events}
                        {pastEvents}
                    </div>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/Events.jsx.erb